import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useNavigate, Route, Routes } from 'react-router-dom';
import { Auth0Provider } from "@auth0/auth0-react";
import App from './components/app';
import Print from './components/print';
import Contest from './components/contest/contest';

export const Auth0ProviderWithNavigate = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const navigate = useNavigate();
  const domain = "climbing.eu.auth0.com";
  const clientId = "DNJNVzhxbF7PtaBFh7H6iBSNLh2UJWHt";

  const onRedirectCallback = (appState: any) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: 'https://buldreinfo.com',
        scope: 'openid profile email',
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      cacheLocation={'localstorage'}
    >
      {children}
    </Auth0Provider>
  );
};

const Index = () => (
  <BrowserRouter>
    <Auth0ProviderWithNavigate>
      <Routes>
        <Route path="/print/:problemId" element={<Print/>} />
        <Route path="/contest/*" element={<Contest/>} />
        <Route 
          path="/" 
          element={
            window.location.hostname === 'sis.buldreinfo.com' 
              ? <Contest />
              : <App />
          } 
        />
        <Route path="/*" element={<App/>}/>
      </Routes>
    </Auth0ProviderWithNavigate>
  </BrowserRouter>
);

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<Index />);
}